import React from 'react';
import PropTypes from 'prop-types';
import MapContext from '../MapContext';

const sourceId = 'here-traffic';

export default class HereTrafficLayer extends React.Component {
  componentDidMount() {
    const { map } = this.context;

    map.addSource(sourceId, { type: 'raster', tiles: [this.trafficLayerURL()], tileSize: 256, maxzoom: 20 });
    map.addLayer({ id: sourceId, type: 'raster', source: sourceId });

    this.refreshTimer = window.setInterval(() => {
      map.getSource(sourceId).setTiles([this.trafficLayerURL()]);
    }, this.props.refreshTime * 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.refreshTimer);
    if (this.context.isRemoved()) return;

    this.context.map.removeLayer(sourceId);
    this.context.map.removeSource(sourceId);
  }

  trafficLayerURL() {
    const hereApiKey = import.meta.env.VITE_HERE_API_KEY_STELLWERK_MAPS;

    return `https://traffic.maps.hereapi.com/v3/flow/mc/{z}/{x}/{y}/png?apiKey=${hereApiKey}`;
  }

  render() {
    return null;
  }
}

HereTrafficLayer.contextType = MapContext;

HereTrafficLayer.propTypes = {
  refreshTime: PropTypes.number
};

HereTrafficLayer.defaultProps = {
  refreshTime: 180
};
